import { render, staticRenderFns } from "./OfficialFeeList.vue?vue&type=template&id=2c6648b8&scoped=true&"
import script from "./OfficialFeeList.vue?vue&type=script&lang=js&"
export * from "./OfficialFeeList.vue?vue&type=script&lang=js&"
import style0 from "./OfficialFeeList.vue?vue&type=style&index=0&id=2c6648b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6648b8",
  null
  
)

export default component.exports